import { PANEL } from '@/components/layouts'

export default (routes) => routes.map(route => ({
  ...route,
  meta: {
    ...route.meta,
    layout: PANEL
  }
}))
